export * from "./createClient.js";
export { ApolloCache, ApolloClient, ApolloError, ApolloLink, HttpLink, InMemoryCache, MissingFieldError, Observable, ObservableQuery, defaultDataIdFromObject } from '@apollo/client/core';
export { SchemaLink } from '@apollo/client/link/schema';
export { gql } from '@apollo/client/core';
export { relayStylePagination } from '@apollo/client/utilities';
//# sourceMappingURL=core.js.map